const data = {
  "chat": {
    "buttonLabel": "Ga terug naar de live chat",
    "inputLabel": "Stuur een bericht",
    "inputPlaceholder": "Typ hier je bericht...",
    "inputIcon": "Stuur",
    "you": "Jij",
    "disclaimer": "Onze digitale assistent helpt je, maar kan zich net als een mens soms vergissen.",
    "closeChat": "Chat sluiten"
  }
};

export default data;